import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import ElectionFileUpload from "../../../../common/electionsInputField/ElectionFileUpload";
import ElectionInput from "../../../../common/electionsInputField/ElectionInput";
import { useDebounce } from "../../../../common/hooks/useDebounce";
import Loader from "../../../../common/loader/Loader";
import { MessageContext } from "../../../../common/message/MessageContext";
import { GET } from "../../../../utils/fetchUtil";

const createCandidateFileUploadName = "documents";

const CustomCreateCandidate = ({
  active,
  setCandidateModal,
  dispatch,
  electionState,
  setFetchCandidatesTrigger,
}) => {
  const [candidate, setCandidate] = useState(null);
  const [valuesForm, setValuesForm] = useState({
    evidencijskiBroj: "",
    imePrezime: "",
    ustanovaZaposlenja: "",
    dokumentacija: [],
  });
  const debounceEvBroj = useDebounce(valuesForm.evidencijskiBroj, 1000);

  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValuesForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const clearValuesForm = () => {
    setValuesForm({
      evidencijskiBroj: "",
      imePrezime: "",
      ustanovaZaposlenja: "",
      dokumentacija: [],
    });
    setCandidate(null);
    dispatch({ type: "update", payload: { [createCandidateFileUploadName]: [] } });
  };

  useEffect(() => {
    valuesForm.evidencijskiBroj &&
      GET(
        `/userInfo?evidencijskiBroj=${valuesForm.evidencijskiBroj}`,
        (data) => {
          setCandidate(data);
          setValuesForm((prevState) => ({
            ...prevState,
            imePrezime: data.ime + " " + data.prezime,
          }));
          if (data.evidencijskiBroj === null) {
            setCandidate(null);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }, [debounceEvBroj]);

  const handleEvidencijskiBroj = (e) => {
    setValuesForm((prevState) => ({ ...prevState, evidencijskiBroj: e.target.value }));
  };

  // Turn on/off modal
  if (!active) {
    return null;
  }

  const handleCloseBtn = () => {
    // Input fields cleanup
    clearValuesForm();
    setCandidate(null);
    setCandidateModal(false);
  };

  const handleFile = (uploadedFile) => {
    dispatch({ type: "addCandidateDocs", payload: uploadedFile });
  };

  const handleConfirmBtn = async () => {
    if (valuesForm.evidencijskiBroj && valuesForm.imePrezime && valuesForm.ustanovaZaposlenja) {
      let form = new FormData();
      form.append("ElectionId", electionState.id);
      form.append("UserId", candidate?.id > 0 ? candidate.id : "");
      form.append("Institution", valuesForm.ustanovaZaposlenja);
      form.append("NameAndSurname", valuesForm.imePrezime);
      form.append("EvidencijskiBrojEhkms", valuesForm.evidencijskiBroj);

      let ins = electionState[createCandidateFileUploadName]?.length;
      for (var x = 0; x < ins; x++) {
        form.append("documentation", electionState[createCandidateFileUploadName][x]);
      }
      // Loading spinner is active
      setIsLoading(true);

      let requestOptions = {
        method: "POST",
        headers: {
          "Request-Origin": "pisarnica",
          Authorization: "Bearer " + (await getAccessToken()),
        },
        body: form,
        redirect: "follow",
      };
      fetch(`${process.env.REACT_APP_GATEWAY_URL}/candidate`, requestOptions)
        .then((response) => {
          setFetchCandidatesTrigger((prevState) => prevState + 1);
          setIsLoading(false);
          handleCloseBtn();
        })
        .then((result) => {})
        .catch((error) => {
          setIsLoading(false);
          message.toggle({
            title: "Napomena",
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
              handleCloseBtn();
            },
          });
        });
    } else {
      message.toggle({
        title: "Napomena",
        content: "Molimo unesite sve označene podatke.",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    }
  };

  let mainModalContent = (
    <>
      {isLoading ? (
        <Loader size={`6x`} className="is-flex-grow-1 is-align-self-center" />
      ) : (
        <>
          <div className="content">
            <div>
              <h2 className="confirm-modal-mobile-header">Kandidat:</h2>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInput
                  name="evidencijskiBroj"
                  placeholder={"Evidencijski broj"}
                  value={valuesForm.evidencijskiBroj}
                  isRequired={true}
                  onChange={handleEvidencijskiBroj}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInput
                  name="imePrezime"
                  placeholder={"Ime i prezime"}
                  isRequired={true}
                  value={valuesForm.imePrezime}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionInput
                  name="ustanovaZaposlenja"
                  placeholder={"Ustanova Zaposlenja"}
                  isRequired={true}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="p-5 has-text-centered">
              <div className="confirm-modal-mobile-p is-size-5">
                <ElectionFileUpload
                  placeholder={"Dodaj dokumentaciju"}
                  isRequired={false}
                  handleFile={handleFile}
                  name={createCandidateFileUploadName}
                  dispatch={dispatch}
                  electionState={electionState}
                />
              </div>
            </div>
          </div>
          <div className="has-text-centered">
            <button
              className="button is-outlined ml-2 confirm-modal-vote-btn"
              id="closebtn"
              onClick={handleCloseBtn}
            >
              Odustani
            </button>
            <button
              className="button is-success ml-2 confirm-modal-vote-btn"
              id="previous"
              onClick={handleConfirmBtn}
            >
              Spremi kandidata
            </button>
          </div>
        </>
      )}
    </>
  );

  return (
    <div id="modal" className={"modal is-active"}>
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <article className="media">
            <div className="media-left"></div>
            <div style={{ overflow: "hidden" }} className="media-content">
              {mainModalContent}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default CustomCreateCandidate;
